export default __webpack_public_path__ + "7ee46897d26bdbac8f21cb1860fa325e.svg";